import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    standalone: false
})
export class NotFoundComponent{
  constructor() {}
}
